'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAddOnsPageError = exports.loadAddOnsPage = exports.purchaseAddOn = exports.LOAD_ADD_ONS_PAGE_ERROR = exports.LOAD_ADD_ONS_PAGE = exports.PURCHASE_ADD_ON = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.doLoadAddOnsPage = doLoadAddOnsPage;
exports.doPurchaseAddOn = doPurchaseAddOn;
exports.watchAddOnsPageSagas = watchAddOnsPageSagas;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _modals = require('redux/modules/modals');

var _Banners = require('features/Banners/Banners.reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadAddOnsPage),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doPurchaseAddOn),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchAddOnsPageSagas);

var PURCHASE_ADD_ON = exports.PURCHASE_ADD_ON = 'PURCHASE_ADD_ON';

var LOAD_ADD_ONS_PAGE = exports.LOAD_ADD_ONS_PAGE = 'LOAD_ADD_ONS_PAGE';
var LOAD_ADD_ONS_PAGE_ERROR = exports.LOAD_ADD_ONS_PAGE_ERROR = 'LOAD_ADD_ONS_PAGE_ERROR';

var purchaseAddOn = exports.purchaseAddOn = function purchaseAddOn(options) {
  return (0, _extends3.default)({ type: PURCHASE_ADD_ON }, options);
};
var loadAddOnsPage = exports.loadAddOnsPage = function loadAddOnsPage() {
  return { type: LOAD_ADD_ONS_PAGE };
};
var loadAddOnsPageError = exports.loadAddOnsPageError = _helpers.errorActionCreator.bind(null, LOAD_ADD_ONS_PAGE_ERROR);

function doLoadAddOnsPage(client) {
  var profile;
  return _regenerator2.default.wrap(function doLoadAddOnsPage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          profile = _context.sent;
          _context.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userSubscription, [client, profile.id]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.classBundlesByMsa, [client, profile.membership.home_msa_id])]);

        case 6:
          _context.next = 12;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context['catch'](0);
          _context.next = 12;
          return (0, _effects.put)(loadAddOnsPageError(_context.t0));

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 8]]);
}

function doPurchaseAddOn(client, _ref) {
  var bundleId = _ref.bundleId,
      successMessage = _ref.successMessage;
  var profile;
  return _regenerator2.default.wrap(function doPurchaseAddOn$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          profile = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.purchaseClassBundle, [client, profile.id, bundleId]);

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.userCreditBalance, [client, profile.id]);

        case 8:
          _context2.next = 10;
          return (0, _effects.all)([(0, _effects.put)((0, _modals.hideModal)('ClassBundleModal')), (0, _effects.put)((0, _Banners.addSuccessNotification)(successMessage))]);

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](0);

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 12]]);
}

function watchAddOnsPageSagas(client) {
  return _regenerator2.default.wrap(function watchAddOnsPageSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_ADD_ONS_PAGE, doLoadAddOnsPage, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, PURCHASE_ADD_ON, doPurchaseAddOn, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}